<template>
  <header>
    <h1 class="header_logo"><router-link to="/"><img src="../../assets/img/common/header/logo.png" width="183" alt="テレビ朝日映像株式会社" /></router-link></h1><!-- .header_logo -->
    <div id="header_navbox">
      <nav id="g_nav">
        <ul id="g_nav_list">
          <li><router-link to="/news" class="news">NEWS</router-link></li>
          <li><router-link to="/players" class="players">PLAYers</router-link></li>
          <li><router-link to="/works" class="works">WORKS</router-link></li>
          <li><router-link to="/company" class="company">COMPANY</router-link></li>
          <li><router-link to="/recruit" class="recruit">RECRUIT</router-link></li>
          <li class="tapcast_end"><router-link to="/tapcast">TAP CAST 終了のお知らせ</router-link></li>
        </ul>
        <div id="g_nav_sns">
          <p class="youtube"><a href="#"><img src="../../assets/img/common/header/youtube.png"  width="62" alt="Youtube" /></a></p>
          <div class="share_box">
            <div class="share_box_inner">
              <div class="instagram">
                <a href="https://www.instagram.com/tv_asahipro_saiyo/" target="_blank"><img src="../../assets/img/common/header/sns_i.png" width="83" alt="Instagram" /></a>
              </div>
              <div class="share">
                <div class="share_wrap">
                  <h3><img src="../../assets/img/common/header/share_title.png" width="42" alt="SHARE" /></h3>
                  <ul class="share_box_list">
                    <li><a v-bind:href="'https://www.facebook.com/sharer/sharer.php?u=' + current_url " target="_blank"><img src="../../assets/img/common/header/sns_f.png" width="10" alt="Facebook" /></a></li>
                    <li><a v-bind:href="'http://twitter.com/share?url=' + current_url " target="_blank"><img src="../../assets/img/common/header/sns_t.png" width="20" alt="Twitter" /></a></li>
                  </ul>
                </div>
              </div>
            </div><!-- .share_box_inner -->
          </div><!-- .share_box -->
        </div><!-- #gnav_sns -->
      </nav><!-- #g_nav -->
    </div><!-- #header_navbox -->
  </header>
</template>

<script>
export default {
  name: 'headerItem',
  data (){
    return {
      current_url: location.origin
    }
  },
  mounted () {
    var header = document.getElementsByTagName('header');
    if (this.recruit_check()){
      $(header).css('display', 'none');
    }else{
      $(header).css('display', 'flex');
    }
    this.body_color()
  },
  watch: {
    '$route' (to, from) {
      var header = document.getElementsByTagName('header');
      if (this.recruit_check()){
        $(header).css('display', 'none');
      }else{
        $(header).css('display', 'flex');
      }
      this.body_color()
    }
  },
  methods: {
    recruit_check(){
      return ['recruit_2021','recruit_2022','recruit_2023','recruit_2024','recruit_2025','recruit_2025_application','recruit_2025_teaser','recruit_2025_top','recruit_2026','recruit_2026_application','recruit_2026_top','recruit_2027','recruit_2027_application','recruit_2027_top'].includes(this.$route.name)
    },
    body_color(){
      if(this.$route.name == 'recruit_2025' || this.$route.name == 'recruit_2025_application' || this.$route.name == 'recruit_2025_teaser' || this.$route.name == 'recruit_2025_top' || this.$route.name == 'recruit_2026' || this.$route.name == 'recruit_2026_application' || this.$route.name == 'recruit_2026_top' || this.$route.name == 'recruit_2027' || this.$route.name == 'recruit_2027_application' || this.$route.name == 'recruit_2027_top'){
        $("meta[name ='theme-color']").attr('content','#000');
        $("body").css('background','#000');
      } else {
        $("meta[name ='theme-color']").attr('content','#FFF');
        $("body").css('background','#FFF');
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/headerItem.vue